// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__bitp5","header":"card_header__j1oul","image":"card_image__Rk9sp","title":"card_title__ZcOPl","description":"card_description__ywfIc"};